import '@src/assets/styles/empty.scss';

import { safeCredentials, handleErrors } from '@utils/fetchHelpers';
import conversionTracker from '@utils/conversionTracker';

var addRequestSyllabusCallback = function () {
  window.requestSyllabus = function (e) {
    if (e) {
      e.preventDefault();
    }
    const form = document.getElementById('detailedSyllabusRequestContainer');

    const first_name = form.querySelector('input[name="first_name"]').value.trim();
    const email = form.querySelector('input[name="email"]').value.trim();

    let server_data = {};
    const node = document.getElementById('server_data');
    if (node) {
      server_data = JSON.parse(node.getAttribute('data'));
    }

    if (!first_name || !email) {
      alert('please provide name and email');
      return;
    }

    form.querySelector('button[name="submit"]').disabled = true;

    fetch('/api/v2/email_subscriptions/request_syllabus_using_ck_tag', safeCredentials({
      method: 'POST',
      body: JSON.stringify({
        first_name: first_name,
        email: email,
        id: server_data.params.slug,
      }),
    }))
    .then(handleErrors)
    .then(res => {
      if (res.success) {
        conversionTracker(window, 'Lead', {
          content_category: 'syllabus_request',
          content_name: server_data.params.slug,
          first_name: first_name,
          email: email,
        });

        form.classList.toggle('d-none');
        document.querySelector('#syllabusModal .successMessage').classList.toggle('d-none');
      } else {
        form.querySelector('button').disabled = false;
        window.alert("Failed to send, please try again later.");
      }
    })
    .catch((error) => {
      window.alert("Failed to send, please try again later.");
      console.error(error);
    });
  };

  window.resetSyllabusModal = function (e) {
    window.setTimeout(function () {
      document.getElementById('detailedSyllabusRequestContainer').classList.toggle('d-none');
      document.querySelector('#syllabusModal .successMessage').classList.toggle('d-none');
    },1000);
  }
}

var activateMenu = function () {
  const adjustMenuPosition = function () {
    const menu = document.getElementById('menu');
    window.requestAnimationFrame(() => {
      const syllabusContainer = document.getElementById('syllabusContainer');

      const pageOffset = window.pageYOffset;
      const windowHeight = window.innerHeight;
      const pageHeight = syllabusContainer.scrollHeight;
      const inflectionPoint = 1;
      const sideMenuWrapperHeight = menu.scrollHeight;
      const distanceFromBottom = pageHeight - windowHeight - pageOffset + (windowHeight - sideMenuWrapperHeight);

      if (pageOffset >= inflectionPoint) {
        menu.classList.add('fixed');
      } else {
        if (menu.classList.contains('fixed')) {
          menu.classList.remove('fixed');
        }
      }

      if (distanceFromBottom <= 200) {
        menu.style.position = 'absolute';
        menu.style.top = 'initial';
        menu.style.bottom = '152px';
      } else {
        menu.style.position = '';
        menu.style.top = '';
        menu.style.bottom = '';
      }
    });
  }

  window.addEventListener('scroll', adjustMenuPosition, { passive: true });
}

window.addEventListener('load', (event) => {
  activateMenu();
  addRequestSyllabusCallback();  
});
